import { ApplicationConfig } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';

export const EN_DATE_FORMAT: MatDateFormats = {
  parse: {
    dateInput: ['l', 'LL'],
  },
  display: {
    dateInput: 'DD-MMMM-y',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

function getTranslatePrefix(): string {
  if (environment.translationsSource === 'server') {
    return environment.api.host + '/lokalise/';
  }
  return './assets/i18n/';
}

// INFO MPS : The file allow you to add the provider specific to your application without having to modify the bootstrap configuration
// provided in the 'mps.config.ts' file of the 'mps' folder. This 'application.config.ts' file is imported after the 'mps.config.ts' file
// in the 'global.config.ts' file which means it will also override the providers defined in the 'mps.config.ts' file.
// Use it with caution when overriding the 'mps.config.ts' and make sure to override properly the config without breaking the application.
export const applicationConfig: ApplicationConfig = {
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: MAT_DATE_FORMATS, useValue: EN_DATE_FORMAT },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 5000, horizontalPosition: 'right', verticalPosition: 'top' },
    },
    // { Uncomment if form field don't need hint space at bottom of fields
    //   provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    //   useValue: { subscriptSizing: 'dynamic', appearance: 'outline', floatLabel: 'auto' },
    // },
    provideTranslateService({
      fallbackLang: environment.defaultLocale,
      loader: provideTranslateHttpLoader({ prefix: getTranslatePrefix(), suffix: '.json' }),
    }),
  ],
};
